module.exports = {
	"id": "MO",
	"name": "Macao",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.037681,
			"12": 0.016149,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": 0.005383,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.021532,
			"22": 0.032298,
			"23": null,
			"24": null,
			"25": 0.048447,
			"26": 0.016149,
			"27": 0.010766,
			"28": 0.010766,
			"29": 0.005383,
			"30": 0.059213,
			"31": 0.064596,
			"32": 0.010766,
			"33": 0.021532,
			"34": 0.026915,
			"35": 0.032298,
			"36": 0.064596,
			"37": 0.016149,
			"38": 0.069979,
			"39": 0.086128,
			"40": 0.059213,
			"41": 0.021532,
			"42": 0.382193,
			"43": 0.150724,
			"44": 0.10766,
			"45": 1.200409,
			"46": 0.091511,
			"47": 0.21532,
			"48": 0.113043,
			"49": 1.577219,
			"50": 0.759003,
			"51": 0.898961,
			"52": 2.061689,
			"53": 20.159335,
			"54": 5.033105,
			"55": 0.075362,
			"56": 0.010766,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.005383,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.032298,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.005383,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.005383,
			"30": null,
			"31": null,
			"32": 0.016149,
			"33": 0.016149,
			"34": 0.005383,
			"35": 0.005383,
			"36": null,
			"37": null,
			"38": 0.032298,
			"39": 0.048447,
			"40": 0.118426,
			"41": 0.010766,
			"42": 0.021532,
			"43": 0.075362,
			"44": 0.005383,
			"45": 0.032298,
			"46": 0.021532,
			"47": 0.344512,
			"48": 0.247618,
			"49": 3.380524,
			"50": 0.026915,
			"51": null,
			"52": 0.021532,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.021532,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.005383,
			"37": 0.016149,
			"38": 0.005383,
			"39": null,
			"40": 0.123809,
			"41": 0.026915,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.048447
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.021532,
			"6": 0.118426,
			"7": 0.096894,
			"8": 0.366044,
			"9": 0.419874,
			"10": 1.480325,
			"3.1": null,
			"3.2": null,
			"5.1": 0.10766,
			"6.1": 0.080745,
			"7.1": 0.010766,
			"9.1": 1.114281
		},
		"ios_saf": {
			"8": 0,
			"10": 17.5987892023,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.474267004996,
			"8.1-8.4": 0.87618819567,
			"9.0-9.2": 0.417998038301,
			"9.3": 6.3771495587
		},
		"android": {
			"3": 0,
			"4": 0.0291455581395,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00364319476744,
			"4.1": 0.10513219186,
			"4.2-4.3": 0.262830479651,
			"4.4": 0.602688505814,
			"4.4.3-4.4.4": 0.607893069767
		},
		"ie": {
			"6": 0.0169096864865,
			"7": 0.0112731243243,
			"8": 0.603112151351,
			"9": 0.636931524324,
			"10": 0.620021837838,
			"11": 5.38291686486,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0101888170574,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00028302269604
		},
		"edge": {
			"12": 0.059213,
			"13": 0.581364,
			"14": 0.759003
		},
		"ie_mob": {
			"10": 0.0218494647887,
			"11": 0.0889585352113
		},
		"bb": {
			"7": 0.0069255,
			"10": null
		},
		"samsung": {
			"0": 4.275342
		},
		"and_uc": {
			"0": 1.445121
		},
		"op_mini": {
			"0": 0.137272160247
		},
		"and_chr": {
			"0": 14.390548
		},
		"and_ff": {
			"0": 0.050787
		}
	},
	"total": 98.5703376892
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MO.json
 ** module id = 592
 ** module chunks = 0
 **/